import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12114a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk" }
const _hoisted_2 = { class: "rk_info" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("机台/工位：")
const _hoisted_4 = { class: "material-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-prefix" }),
  /*#__PURE__*/_createElementVNode("span", null, "完工交接物料")
], -1))
const _hoisted_6 = { class: "order-time" }
const _hoisted_7 = { class: "material-content" }
const _hoisted_8 = {
  key: 0,
  class: "item-style"
}
const _hoisted_9 = { class: "item-title-style" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "green" }, "[合格品] ", -1))
const _hoisted_11 = { style: {"font-weight":"500"} }
const _hoisted_12 = { class: "item-content-style" }
const _hoisted_13 = { class: "subItem-style_top" }
const _hoisted_14 = { class: "subItem-first-style" }
const _hoisted_15 = { class: "subItem-second-style" }
const _hoisted_16 = { class: "subItem-style_bottom" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "item-style"
}
const _hoisted_20 = { class: "item-title-style" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yellow" }, "[不良品] ", -1))
const _hoisted_22 = { style: {"font-weight":"500"} }
const _hoisted_23 = { class: "item-content-style" }
const _hoisted_24 = { class: "subItem-style_top" }
const _hoisted_25 = { class: "subItem-first-style" }
const _hoisted_26 = { class: "subItem-second-style" }
const _hoisted_27 = { class: "subItem-style_bottom" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 2,
  class: "item-style"
}
const _hoisted_31 = { class: "item-title-style" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "[报废品] ", -1))
const _hoisted_33 = { style: {"font-weight":"500"} }
const _hoisted_34 = { class: "item-content-style" }
const _hoisted_35 = { class: "subItem-style_top" }
const _hoisted_36 = { class: "subItem-first-style" }
const _hoisted_37 = { class: "subItem-second-style" }
const _hoisted_38 = { class: "subItem-style_bottom" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "rk_sc" }
const _hoisted_42 = { class: "rk_sc_header" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_sc_header_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rk_sc_header_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "本次余留次班生产")
], -1))
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 0,
  class: "rk_sc_content"
}
const _hoisted_46 = { class: "rk_sc_content_item_a" }
const _hoisted_47 = { class: "rk_sc_content_item_b" }
const _hoisted_48 = { class: "rk_sc_content_item_hz" }
const _hoisted_49 = { class: "rk_sc_content_item_hz_item_top" }
const _hoisted_50 = { class: "rk_sc_content_item_hz_item_bottom" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "succ" }, "合格", -1))
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yellow" }, "不良", -1))
const _hoisted_55 = { key: 2 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning" }, "报废", -1))
const _hoisted_57 = {
  key: 1,
  class: "rk_sc_kong"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = {
  key: 0,
  class: "rk_zw"
}
const _hoisted_61 = {
  key: 1,
  class: "rk_footer"
}
const _hoisted_62 = /*#__PURE__*/_createTextVNode("去入库")
const _hoisted_63 = [
  _hoisted_62
]

import { ref, onMounted } from 'vue'
    import { useRouter, useRoute } from "vue-router"
    import { getFinishRecord } from '@/apis/WorkOrderAPI'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    let info: any = ref([])
    let wlInfo: any = ref({})

    const statistics = (arr: Array<any>): string => {
        let boxNum: number = 0
        let num: number = 0
        let dw: string = ''
        arr.forEach((element: any) => {
            if (element.reserveMaterialBeanList && element.reserveMaterialBeanList.length > 0) {
                element.reserveMaterialBeanList.forEach((element1: any, index: number) => {
                    if (index === 0) {
                        dw = element1.unitName
                    }
                    boxNum = boxNum + element1.boxNum
                    num = num + element1.num
                    console.log(boxNum, num, dw)
                })
            }
        })
        return boxNum + '盒' + ' | ' + num + dw
    }

    const wTotal = (hg: object, bl: object, bf: object): string => {
        let boxNum: number = 0
        let num: number = 0
        let dw: string = ''
        let arr: Array<any> = []
        if (hg) {
            arr.push(hg)
        }
        if (bl) {
            arr.push(bl)
        }
        if (bf) {
            arr.push(bf)
        }
        arr.forEach((element: any, index: number) => {
            if (index === 0) {
                dw = element.unitName
            }
            boxNum = boxNum + element.boxNum
            num = num + element.num
        })
        return boxNum + '盒' + ' | ' + num + dw
    }

    const total = (arr: Array<any>): string => {
        let dw: string = ''
        let boxNum: number = 0
        let sumNum: number = 0
        if (arr.length > 0) {
            arr.forEach((element: any, index: number) => {
                if (index === 0) {
                    dw = element.unitName
                }
                boxNum = boxNum + element.sumBox
                sumNum = sumNum + element.sumNum
            })
        }
        return boxNum + '盒' + ' | ' + sumNum + dw
    }

    // 完工入库提交
    const submit = () => {
        router.replace({ name: 'warehousing', query: { id: route.query.id, dbid: route.query.dbid, type: 7, Type: route.query.Type } })
    }

    // 获取详情
    const finishedDetails = () => {
        getFinishRecord({
            id: route.query.id
        }).then(res => {
            if (res.code === 200) {
                info.value = JSON.parse(res.data.abstracts)
                wlInfo.value = res.data.wtransfer
            }
        })
    }

    onMounted(() => {
        finishedDetails()
    })

return (_ctx: any,_cache: any) => {
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "作业员：" + _toDisplayString(_unref(info).worker) + "/" + _toDisplayString(_unref(info).groupName), 1),
      _createElementVNode("span", null, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).deviceList, (item, i) => {
          return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(item.name) + " " + _toDisplayString(i === _unref(info).deviceList.length - 1 ? '' : '/'), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, "单号：" + _toDisplayString(_unref(wlInfo).code), 1),
        _createElementVNode("div", null, "时间：" + _toDisplayString(_unref(wlInfo).createTime), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_unref(info).qualifiedBeanList && _unref(info).qualifiedBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(total(_unref(info).qualifiedBeanList)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).qualifiedBeanList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subItem-style",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.sumBox) + "盒 | " + _toDisplayString(item.sumNum) + _toDisplayString(item.unitName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (item.batch)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | " + _toDisplayString(item.batch), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.procedureName), 1))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(info).rejectsBeanList && _unref(info).rejectsBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(total(_unref(info).rejectsBeanList)), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).rejectsBeanList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subItem-style",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(item.sumBox) + "盒 | " + _toDisplayString(item.sumNum) + _toDisplayString(item.unitName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (item.batch)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | " + _toDisplayString(item.batch), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.procedureName), 1))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(info).scrapBeanList && _unref(info).scrapBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("span", _hoisted_33, _toDisplayString(total(_unref(info).scrapBeanList)), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).scrapBeanList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subItem-style",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(item.sumBox) + "盒 | " + _toDisplayString(item.sumNum) + _toDisplayString(item.unitName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    (item.batch)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | " + _toDisplayString(item.batch), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(item.procedureName), 1))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        (_unref(info).finishedInBillBeanList && _unref(info).finishedInBillBeanList.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(statistics(_unref(info).finishedInBillBeanList)), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(info).finishedInBillBeanList && _unref(info).finishedInBillBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).finishedInBillBeanList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "rk_sc_content_item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_46, _toDisplayString(item.code), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", null, "接收人：" + _toDisplayString(item.userName) + " / " + _toDisplayString(item.departmentName), 1),
                  _createElementVNode("span", null, "时间：" + _toDisplayString(item.dealDate), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.reserveMaterialBeanList, (items, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "rk_sc_content_item_hz_item",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", null, _toDisplayString(items.materialName) + " | " + _toDisplayString(items.materialCode), 1),
                        _createElementVNode("span", null, _toDisplayString(items.boxNum) + "盒 | " + _toDisplayString(items.num) + _toDisplayString(items.unitName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        (items.qualityType === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                              _hoisted_52,
                              _createTextVNode(" | " + _toDisplayString(items.procedureName) + _toDisplayString(items.batch ? ' | ' + items.batch : ''), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (items.qualityType === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                              _hoisted_54,
                              _createTextVNode(" | " + _toDisplayString(items.procedureName) + _toDisplayString(items.batch ? ' | ' + items.batch : ''), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (items.qualityType === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                              _hoisted_56,
                              _createTextVNode(" | " + _toDisplayString(items.procedureName) + _toDisplayString(items.batch ? ' | ' + items.batch : ''), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
    ]),
    (_unref(route).query.isShow === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_60))
      : _createCommentVNode("", true),
    (_unref(route).query.isShow === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "rk_footer_u",
            onClick: submit
          }, _hoisted_63)), [
            [_directive_preventReClick]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})